import { render, staticRenderFns } from "./sites.vue?vue&type=template&id=8c715ce6&scoped=true&"
import script from "./sites.vue?vue&type=script&lang=js&"
export * from "./sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c715ce6",
  null
  
)

export default component.exports